import { Directive } from '@angular/core';

@Directive({
  selector: '[myAccountLink]',
})
export class MyAccountLinkDirective {
  constructor() {}
}
